export const authentication = {
  confirmEmail: {
    anActivationEmailHasBeenSent: 'En aktiveringslänk har skickats, var vänlig verifiera din e-post',
    weHaveSentActivationLinkToEmailAddress: 'Vi har skickat en aktiveringslänk till e-postadressen',
    toVerifyYourAccount: `för att 'Verifiera ditt konto'.`,
    onceVerifiedAutomaticallyRedirected: 'När verifierat kommer du automatiskt omdirigeras till panelen.',
    didNotReceiveAnEmail: `Har du inte fått ett e-postmeddelande? Kolla din skräppostmapp`,
    resendIn: 'Skicka igen om ',
    seconds: ' sekunder',
    resend: 'Skicka igen',
    backToSignUp: 'Tillbaka till Registrering',
    greatPleaseCheckYourMessage: 'Toppen, var vänlig och kontrollera din e-post',
    weHaveSentEmailTo: 'Vi har skickat ett e-postmeddelande till',
    withALinkToReset: ` med en länk för att återställa ditt konto. När det är aktiverat kan du slutföra skapandet av ditt konto och börja din gratis provperiod.`,
    resent: 'Skickat igen',
    backToLogin: 'Tillbaka till Logga in',
  },
  forgotPassword: {
    forgotPassword: 'Glömt lösenord?',
    noWorries: 'Inga bekymmer,',
    weWillSendYouResetPasswordInstructions: `vi skickar dig instruktioner för att återställa lösenordet`,
    workEmail: 'Jobbmejl',
    continue: 'Fortsätt',
    backToLogin: 'Tillbaka till Logga in',
    placeholders: {
      enterYourEmail: 'Ange din e-post',
    },
  },
  logout: {
    logout: 'Logga ut',
    wantToLogOut: 'Är du säker på att du vill logga ut?',
    yesIWillBeBack: `Ja, jag kommer tillbaka`,
    cancel: 'Avbryt',
  },
  newPassword: {
    createNewPassword: 'Skapa nytt lösenord',
    yourNewPasswordMustBeDifferent: 'Ditt nya lösenord måste vara olikt tidigare använda lösenord.',
    password: 'Lösenord',
    confirmPassword: 'Bekräfta lösenord',
    setPassword: 'Ställ in lösenord',
    signUp: 'Registrera dig',
    login: 'Logga in',
    backTo: 'Tillbaka till ',
    setAPassword: 'Ställ in ett lösenord',
    setNewPasswordToYourAccount: 'Ställ in ett nytt lösenord för ditt konto av säkerhets- och integritetsskäl',
    backToSignUp: 'Tillbaka till Registrering',
    placeholders: {
      enterYourPassword: 'Ange ditt lösenord',
    },
  },
  resetPassword: {
    passwordReset: 'Återställning av lösenord',
    yourPasswordHasBeenSuccessfullyReset: 'Ditt lösenord har återställts framgångsrikt.',
    clickBelowToLogIn: 'Klicka nedan för att logga in',
    continueToLogin: 'Fortsätt till Logga in',
  },
  newSignUp: {
    welcomeBack: 'Välkommen tillbaka ',
    to: 'till',
    logIn: 'Logga in ',
    as: 'som ',
    withFacebook: 'med Facebook',
    logInWithGoogle: 'Logga in med Google',
    or: 'ELLER',
    pleaseFillAValidWorkEmail: 'Vänligen fyll i en giltig arbetsmejladress*',
    workEmailIsRequired: 'Arbetsmejl krävs*',
    pleaseFillAValidPassword: 'Vänligen fyll i ett giltigt lösenord*',
    passwordIsRequired: 'Lösenord krävs*',
    rememberMe: 'Kom ihåg mig',
    forgotPassword: 'Glömt lösenordet?',
    login: 'Logga in',
    doNotHaveAnAccount: `Har du inget konto?`,
    setUpAFreeAccount: 'Skapa ett GRATIS konto',
    noCreditCardRequired: 'Inget kreditkort krävs',
    cancelAnytime: 'Avbryt när som helst',
    signUp: 'Registrera dig ',
    signUpWithGoogle: 'Registrera dig med Google',
    emailIsAlreadyRegistered: 'E-posten är redan registrerad hos oss, klicka på Logga in för att fortsätta',
    phoneNumberShouldHaveMinimum7Digits: 'Telefonnummer bör ha minst 7 siffror*',
    phoneNumberIsRequired: 'Telefonnummer krävs*',
    passwordMustContain: 'Lösenordet måste innehålla',
    atleast6Characters: 'minst 6 tecken, ',
    oneUpperCaseLetter: '1 versalt bokstav ',
    oneSpecialCharacter: '1 specialtecken*',
    alreadyHaveAccount: 'Har du redan ett konto?',
    signingUpToBotPenguinIsAConsentToOur: 'Att registrera dig för ett BotPenguin-konto är ditt samtycke till vår ',
    privacyPolicy: 'Integritetspolicy',
    termsAndConditions: 'Villkor',
    and: ' och ',
    english: 'Engelska',
    hindi: 'Hindi',
    german: 'Tyska',
    french: 'Franska',
    portuguese: 'Portugisiska',
    spanish: 'Spanska',
    italian: 'Italienska',
    russian: 'Ryska',
    placeholders: {
      workEmail: 'Arbetsmejl*',
      password: 'Lösenord*',
      phone: 'Telefon*',
    },
  },
  unsubscribe: {
    successfullyUnsubscribed: 'Avregistrering lyckades',
    yourEmail: 'Din e-post ',
    haveBeenSuccessfullyUnsubscribedFrom: ' har framgångsrikt avregistrerats från',
    backToLogin: 'Tillbaka till Logga in'
  }
};
